<template>
  <ul :id="`tree-node-actions-${nodo.id}`">
    <li>
      <a
        class="a-tooltip-primary a-tooltip-bottom"
        :data-tooltip-text="$t('mEditionAssetContentsTreeNodeActions.actions.questions')"
        href="#"
        @click.prevent="selectNode"
      >
        <i class="fas fa-question-circle"></i>
      </a>
      <span
        v-if="nodo.total > 0"
        class="pending-number"
      >
        {{ nodo.total }}
      </span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'MoleculeEditionMapPathTreeNodeActionsQuestions',

  props: {
    contenido: Object,
    nodo: Object
  },

  methods: {
    selectNode () {
      this.$store.commit('setAssetSelectedNode', Object.assign({}, this.nodo))
    }
  }
}
</script>
